import React, { Component } from 'react';
import { connect } from 'dva';
import classnames from 'classnames';
import { Spin, Table, Button, message, Alert, Modal } from 'antd';
import { downloadClassMasterUrl, uploadClassMasterUrl } from '@/services/contacts/role';
import Upload from '@/components/Upload';
import styles from './index.less';

@connect(({ roleManagement, loading }) => ({
  classMasterList: roleManagement.classMasterList,
  loading: loading.effects['roleManagement/fetchClassMasterList'],
}))
class ClassMasterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileList: [], // 模板列表
      isUpload: false,
      visible: false,
    };

    this.handleOk = this.handleOk.bind(this);
    this.renderUpload = this.renderUpload.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleBeforeUpload = this.handleBeforeUpload.bind(this);
  }

  componentDidMount() {
    this.handleFetchData();
  }

  handleFetchData = () => {
    const { dispatch } = this.props;

    dispatch({
      type: 'roleManagement/fetchClassMasterList',
    });
  };

  handleOk({ file }) {
    const { handleVisibleChange } = this.props;

    if (handleVisibleChange) {
      handleVisibleChange(false);
    }

    this.setState(
      {
        isUpload: false,
        importData: file.response.data,
      },
      () => {
        this.setState({ visible: true });
      }
    );

    this.handleFetchData();
  }

  // 上传，保存上传的值
  handleUpload({ fileList }) {
    this.setState({ fileList });
  }

  // 上传之前，
  handleBeforeUpload() {
    const { fileList = [] } = this.state;

    if (fileList && fileList.length === 1) {
      message.warning('只能上传一个Excel');
      return false;
    }

    this.setState({
      isUpload: true,
    });

    return true;
  }

  // 渲染上传
  renderUpload = () => {
    const { fileList, isUpload } = this.state;
    // 附件
    const uploadProps = {
      multiple: false,
      fileList,
      actionUrl: uploadClassMasterUrl,
      accept: ['.xls', '.xlsx'],
      handleOk: this.handleOk,
      handleBeforeUpload: this.handleBeforeUpload,
      handleSave: this.handleUpload,
      tip: '',
      btnText: '导入excel',
      btnProps: {
        disabled: fileList && fileList.length === 1,
      },
    };

    const cls = classnames(['modal-uploade', !isUpload && 'notUpload']);

    return (
      <div className={cls}>
        <Upload {...uploadProps} />
      </div>
    );
  };

  // 渲染表格
  renderClassMasterTable = (classMasterList = []) => {
    const columns = [
      {
        title: '班级',
        dataIndex: 'className',
        key: 'className',
        width: '20%',
      },
      {
        title: '班主任',
        dataIndex: 'classMasterNameStr',
        key: 'classMasterNameStr',
        width: '40%',
      },
      {
        title: '老师',
        dataIndex: 'teacherNameStr',
        key: 'teacherNameStr',
        width: '40%',
      },
    ];
    return (
      <div className="class-master-table">
        <Table
          columns={columns}
          dataSource={classMasterList}
          pagination={false}
          scroll={{ y: 400 }}
        />
      </div>
    );
  };

  render() {
    const { visible, importData = {} } = this.state;
    const {
      suceesfulSum = 0,
      failedSum = 0,
      sameNameList = [],
      inexistentNameList = [],
      illegalClassList = [],
    } = importData || {};
    const { loading, classMasterList } = this.props;
    return (
      <div className={styles['class-master-modal']}>
        <Spin tip="加载中" spinning={loading} className="class-master-container">
          <Alert
            message="使用说明"
            description="请点击按钮，下载excel模版并认真填写，然后上传excel完成老师批量设置"
            type="info"
          />

          <div className="btn-container">
            <a className="modal-down-btn" href={downloadClassMasterUrl}>
              <Button>下载Excel模板</Button>
            </a>
            {this.renderUpload()}
          </div>
          {this.renderClassMasterTable(classMasterList)}
          <Modal
            title="导入结果"
            visible={visible}
            centered
            className={styles['import-result-modal']}
            footer={[
              <Button type="primary" onClick={() => this.setState({ visible: false })}>
                确定
              </Button>,
            ]}
            onCancel={() => this.setState({ visible: false })}
          >
            <div>
              <span style={{ color: '#87d068' }}>成功人员总数：</span>
              <span>{suceesfulSum}</span>
            </div>
            <div>
              <span style={{ color: '#f50' }}>操作失败人数：</span>
              <span>{failedSum}</span>
            </div>
            <div>
              <span style={{ color: '#2db7f5' }}>同名人员列表：</span>
              <span>{sameNameList.length > 0 ? sameNameList.join('、') : '无'}</span>
            </div>
            <div>
              <span style={{ color: '#108ee9' }}>不存在成员列表：</span>
              <span>{inexistentNameList.length > 0 ? inexistentNameList.join('、') : '无'}</span>
            </div>
            <div>
              <span style={{ color: '#108ee9' }}>不存在班级或班级重名：</span>
              <span>{illegalClassList.length > 0 ? illegalClassList.join('、') : '无'}</span>
            </div>
          </Modal>
        </Spin>
      </div>
    );
  }
}

export default ClassMasterModal;
